exports = module.exports = require("../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".danger-button[data-v-350a8025] {\n  color: #f56c6c;\n}\n.edit-button[data-v-350a8025] {\n  color: #5688fc;\n}", ""]);

// exports
